import locations from './locations.json';
import humans from './humans.json';

export const gameData = {
    locations,
    humans
};

export { locations, humans };